<script setup lang="ts">
/**
 * Переключатель вида проекта — макет 34:254: сегмент 174×32, вкладки 28 с
 * иконкой и подписью, активная белая с тенью.
 *
 * Ссылки, а не кнопки: вид — это адрес (`/p/DEV/board` против `/p/DEV/issues`).
 * Его пересылают в чате и открывают в новой вкладке, и то и другое от кнопки
 * с обработчиком не работает.
 */
import { Columns3, List } from 'lucide-vue-next'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { sharedQueryOf } from '@/features/issues/listState'

defineProps<{ projectKey: string }>()

const { t } = useI18n()
const route = useRoute()

// Общая часть отбора переезжает вместе с видом (DEV-2040): человек, отобравший
// задачи Михаила, ждёт их же и на доске. Локальное для вида (таб, колонка,
// страница) остаётся у вида — доска его всё равно не применяет.
const shared = computed(() => sharedQueryOf(route.query))
</script>

<template>
  <nav class="vswitch" :aria-label="t('toolbar.view.label')">
    <RouterLink
      class="vswitch__tab"
      active-class="vswitch__tab--active"
      :to="{ path: `/p/${projectKey}/board`, query: shared }"
    >
      <Columns3 :size="14" />
      {{ t('toolbar.view.board') }}
    </RouterLink>

    <RouterLink
      class="vswitch__tab"
      active-class="vswitch__tab--active"
      :to="{ path: `/p/${projectKey}/issues`, query: shared }"
    >
      <List :size="14" />
      {{ t('toolbar.view.list') }}
    </RouterLink>
  </nav>
</template>

<style scoped>
.vswitch {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
  padding: 2px;
  border-radius: 9px;
  background: var(--color-bg-muted);
}

.vswitch__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 7px;
  color: var(--color-text-secondary);
  font-size: var(--font-size-body-sm);
  text-decoration: none;
  white-space: nowrap;
}

.vswitch__tab:hover {
  color: var(--color-text-primary);
}

.vswitch__tab--active {
  background: var(--color-surface);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-sm);
}
</style>
